<template>
  <div class="assetsStatisticsRecord">
    <van-steps
      direction="vertical"
      active-color="#38f"
      :active="0"
      v-if="logs && logs.length > 0"
    >
      <van-step v-for="(log, index) in logs" :key="index">
        <h3>{{ log.OperationInstructionsStr }}</h3>
        <div style="margin-bottom: 5px">
          {{ $t.enterpriseLogistics.handoverDate }}: {{ log.CreateTime }}
        </div>
        <div style="margin-bottom: 5px">
          {{ $t.enterpriseLogistics.incharge }}: {{ log.Surname }}
        </div>
        <div>
          {{ $t.enterpriseLogistics.assetState }}:
          <span v-if="log.AssetState == 0">{{
            $t.enterpriseLogistics.aState1
          }}</span>
          <span v-if="log.AssetState == 1">{{
            $t.enterpriseLogistics.aState2
          }}</span>
        </div>
      </van-step>
    </van-steps>
    <div class="empty-text" v-else>{{ $t.meta.noData }}</div>
  </div>
</template>
<script>
import Vue from "vue";

import { Step, Steps } from "vant";

Vue.use(Step).use(Steps);

export default {
  name: "assetsStatisticsRecord",
  data() {
    return {
      AssetId: "",
      logs: [],
    };
  },
  created() {
    const { AssetId } = this.$route.query;
    this.AssetId = AssetId;
    this.getAssetHandoverRecordsListByAssetId();
  },
  methods: {
    getAssetHandoverRecordsListByAssetId() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          AssetId: this.AssetId,
          PageIndex: 1,
          PageSize: 999,
        };
        this.$api.businessLogistics
          .getAssetHandoverRecordsListByAssetId(param)
          .then((res) => {
            this.logs = res.data.Data || [];
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(
              this.$commonEnv.actionType.showDialog,
              {
                msg: error.message,
              }
            );
            reject();
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.assetsStatisticsRecord {
  ::v-deep .number-label {
    line-height: 33px;
  }
  .van-steps {
    background: transparent;
  }
  .empty-text {
    text-align: center;
    padding: 50px;
    font-size: 14px;
    color: #969799;
  }
}
</style>
